export const environment = {
  production: true,
  serverUrl: window.location.origin + "/API/",
  symbolURL: "FrostMeasurements/Icon/"
};
